module.exports = __webpack_public_path__ + "static/media/staggered.e9640fda.png";